import { createFileRoute, redirect } from '@tanstack/react-router';
import { validateLocationSearch } from '@/features/locations/search';

/** Locations is now the Board. */
export const Route = createFileRoute('/app/locations/')({
  beforeLoad: ({ location }) => {
    throw redirect({ to: '/app/board', search: validateLocationSearch(location.search as Record<string, unknown>), replace: true });
  },
});
